import React from "react";
import maatregelenSvg from "../../../../content/images/table/XMLID_3_.svg";
import $ from "jquery";
import ColumnList from "../../../common/componet-jsons/column-list-catalog.json";
import "./variable/v";
import * as omnimap from "../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "./functions/callBackFunctions";
import * as GC from "../../../common/common";
class Table extends React.Component {
  fillTable(model, page_number) {
    var that = this;
    window.$catalog_discipline_lastUsedTableFilter = model;

    omnimap
      .FillTableAction(
        model,
        page_number,
        window.$catalog_management_units_token
      )
      .then((result) => {
        CallBackFunctions.FillTableCallBack(result, page_number);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  /**(FUNCTION) Tabloların sütün Aramlarının Anlık Yapılmasını Sağlayan Fonsiyon. */
  searchFilterColumns(key, searchId) {
    var that = this;
    var model = {
      definitions: [process.env.REACT_APP_CATALOG_DISCIPLINE],
    };
    var url =
      "https://" +
      process.env.REACT_APP_BASE_URL +
      "/omnimap/search/definitions/content/keys/" +
      searchId +
      "/values?q=" +
      key;

    omnimap
      .SearchFilterColumnsAction(
        model,
        key,
        searchId,
        window.$catalog_management_units_token
      )
      .then((result) => {
        CallBackFunctions.SearchFilterColumnsCallBack(searchId, result);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  componentDidMount() {
    var that = this;

    if (window.$catalog_management_units_token == null) {
      window.$catalog_management_units_token = GC.GetToken().then((token) => {
        window.$catalog_management_units_token = token;
        ReloadData(1);
      });
    } else ReloadData(1);

    ColumnList.forEach(function (item) {
      if (item.name == "catalog>discipline") {
        window.$catalog_discipline_columnList = item["column-list"];
      }
    });

    $("#detailSide").addClass("d-none");

    // Setup - add a text input to each footer cell
    $("#example thead tr").clone(true).appendTo("#example thead");

    $("#example thead tr:eq(1) th").each(function (i) {
      if (i > 1) {
        var title = $(this).text();
        var row = $.grep(window.$catalog_discipline_columnList, function (v) {
          return v.row === i;
        });
        var rowId = row[0].id;
        if (row[0].filter == true) {
          $(this).html(
            '<input type="search" class="col-search" id="' + rowId + '" />'
          );
          $("input", this).on("keyup change", function () {
            if (table.column(i).search() !== this.value) {
              table.column(i).search(this.value).draw();
            }
          });
        } else {
          $(this).html("");
        }
      } else if (i == 0) {
        //$(this).html( '<div class="popup threedots" onclick="Popup()"><span class="popuptext" id="myPopup"><a class="maatregelen" href="#">Maatregelen</a><a class="locate" href="#">Beheer gebieden</a><a class="map" href="#">Toon op kaart</a><a class="trash-bin" href="#">Verwijderen</a></span></div>' );
        $(this).html(
          '<div class="popup threedots" onclick="Popup()"><span class="popuptext" id="myPopup"></span></div>'
        );
      } else if (i == 1) {
        $(this).html('<div class="refresh"> </div>');
      } else {
        $(this).html("");
      }
    });
    var table = $("#example").DataTable({
      order: [],
      ordering: false,
      orderCellsTop: true,
      fixedHeader: true,
      colReorder: {
        fixedColumnsLeft: 1
      },
      searching: false,
      paging: false,
      scrollX: true, //"500px",
      scrollY: "calc(100vh - 330px)",

      scrollCollapse: true,
      dom: '<"top"if>t<"bottom"pr><"clear">',
      info: true,
      infoCallback: function (settings, start, end, max, total, pre) {
        return (
          '<span class="select-item"></span>' +
          '<span class="total_right"><span id="total-rows" class="total">' +
          end +
          "</span> geselecteerd </span>"
        );
      },
      language: {
        paginate: {
          previous: "Eerste",
          next: "Laatste",
        },
        select: {
          rows: '<span class="items">%d </span>items van&nbsp;', //'<span class="items">%d </span>items van&nbsp;',
        },
      },
      columnDefs: [
        {
          targets: 0,
          data: null,
          defaultContent: "",
          orderable: false,
          className: "select-checkbox",
        },
      ],
      select: {
        style: "multi+shift",
        selector: "tr",      },
      // Disable sorting on the sorting_disabled class
      aoColumnDefs: [
        {
          bSortable: false,
          aTargets: ["sorting_disabled"],
        },
      ],
    });

    var lastScrollLeft = 0;
    var lastScrollControl = 0.33;
    var buffer = 0.33; // # of pixels from bottom of scroll to fire your function. Can be 0
    $(".dataTables_scrollBody").scroll(function () {
      var documentScrollLeft = $(".dataTables_scrollBody").scrollLeft();
      if (window.$catalog_discipline_scroll_change) {
        if (
          $(".dataTables_scrollBody").prop("scrollHeight") -
            $(".dataTables_scrollBody").scrollTop() <=
          $(".dataTables_scrollBody").height() + buffer
        ) {
          lastScrollControl = 0;
        }
      }
      if (lastScrollLeft == documentScrollLeft + lastScrollControl) {
        if (window.$catalog_discipline_scroll_change) {
          if (
            $(".dataTables_scrollBody").prop("scrollHeight") -
              $(".dataTables_scrollBody").scrollTop() <=
            $(".dataTables_scrollBody").height() + buffer
          ) {
            if (document.getElementById("tableSide").className !== "d-none") {
              if (
                `/${this.baseURI.split("/")[3]}/${
                  this.baseURI.split("/")[4]
                }` === that.props.location.pathname
              ) {
                $("#cover-spin").show(0);
                window.$catalog_discipline_page_number++;
                that.fillTable(
                  window.$catalog_discipline_lastUsedTableFilter,
                  window.$catalog_discipline_page_number
                );
              }
            }
          }
        }
      }
    });
    $("#example thead").on("click", "th", function () {
      var row_index = table.column(this).index();
      var nRow = $("#example thead tr")[0];

      if (
        this.childNodes[0].className != "popup threedots" &&
        this.childNodes[0].className != "refresh"
      ) {
        nRow.childNodes.forEach(function (indx) {
          if (indx.cellIndex != row_index) {
            indx.className = "sorting_disabled";
          }
        });

        if (this.className == "sorting_disabled") {
          this.className = "sorting_asc";
          var row;
          $.each(window.$catalog_discipline_columnList, function (index, data) {
            if (data.row == row_index) {
              row = data;
            }
          });
          ReloadData(1, row.shortType, "ASCENDING", row.shortField);
        } else if (this.className == "sorting_asc") {
          this.className = "sorting_desc";
          var row;
          $.each(window.$catalog_discipline_columnList, function (index, data) {
            if (data.row == row_index) {
              row = data;
            }
          });
          ReloadData(1, row.shortType, "DESCENDING", row.shortField);
        } else if (this.className == "sorting_desc") {
          this.className = "sorting_asc";
          var row;
          $.each(window.$catalog_discipline_columnList, function (index, data) {
            if (data.row == row_index) {
              row = data;
            }
          });
          ReloadData(1, row.shortType, "ASCENDING", row.shortField);
        }

        window.$catalog_discipline_page_number = 1;
      }
    });

    $("#example tbody").on("click", "tr", function () {
      if ($(this).attr("class").toString().indexOf("selected") == -1) {
        $("#selected-rows-count").html(
          table.rows(".selected").count() + Number(1) + " "
        );
      } else {
        $("#selected-rows-count").html(
          table.rows(".selected").count() - Number(1) + " "
        );
      }
    });

    $("#example").on("click", ".checkAll", function (e) {
      $("tbody tr").each(function () {
        $(this).attr("class", "odd selected");
      });
      $("#selected-rows-count").html($(".total").html() + " ");
      $(".checkNone, .checkAll").toggle();
    });
    $("#example_filter input").addClass("search-input-table1");
    $(".search-input-table1").attr("placeholder", "search text");

    $("#example tbody").on("dblclick", "tr", function () {
      // var rowId = this.attributes[1].value;
      var rowId = $(this).attr("rowId");

      $.each(window.$catalog_discipline_Glist, function (index, data) {
        if (data.identification == rowId) {
          window.$catalog_discipline_selectedRow = data;
        }
      });

      fillDetail();
      $("#tableSide").addClass("d-none");
      $("#detailSide").removeClass("d-none");
    });

    // Option to allow selecting rows by clicking on row besides checkbox.
    // $("#example tbody").on("click", "tr", function () {
    //   $(this).toggleClass("selected");
    // });
    // ReloadData(1);

    $(".col-search").on("input", function (e) {
      if (this.value == "") {
        addContentAndFillTable($(this).attr("id"), null);
      }
    });

    table.columns().iterator("column", function (ctx, idx) {
      if (idx > 1) {
        $(table.column(idx).header()).append('<span class="sort-icon"/>');
      }
    });

    $(document).on("click", ".discipline-catalog-action", function () {
      var actionId = $(this).attr("id");
      let modalId = window.$catalog_discipline_actions.filter(
        (act) => act["id"] === actionId
      )[0]["modal"];
      $("#" + modalId).modal("show");
    });
    $(document).on("click", "#discipline_toevoegen", function () {
      $("#discipline_toevoegen_modal").modal("show");
    });

    function ReloadData(page_number, short_type, direction, field) {
      let definition = process.env.REACT_APP_CATALOG_DISCIPLINE;
      if (!short_type) {
        var model = {
          content: [],
          definitions: [definition],
        };
        window.$catalog_discipline_lastUsedTableFilter = model;
      } else {
        var model = {
          content: [],
          definitions: [definition],
          sorting: [
            {
              sort_type: short_type,
              direction: direction,
              field: field,
            },
          ],
        };
        window.$catalog_discipline_lastUsedTableFilter = model;
      }

      that.fillTable(model, page_number);

      fillFilterColumns(definition);
    }

    $("#save_discipline").click(function () {
      var actief;
      if ($("#discipline_active").is(":checked")) {
        actief = true;
      } else actief = false;
      var naam = $("#discipline_naam").val();
      var model = {
        relationships: { definition: { code: "DISCIPLINE" } },
        content: { algemeen: { actief: actief, naam: naam } },
      };
      omnimap
        .SaveOrEditAction(
          model,
          "POST",
          "",
          window.$catalog_management_units_token
        )
        .then(CallBackFunctions.disciplineSaved)
        .catch((error) => {
          console.log(error);
        });
    });

    $("#edit_discipline").click(function () {
      $("#cover-spin").show(0);
      var actief;
      if ($("#e-discipline_active").is(":checked")) {
        actief = true;
      } else actief = false;
      var naam = $("#e-algemeenNaam").val();
      var id = $("#e-identification").val();
      var model = {
        content: { algemeen: { naam: naam, actief: actief } },
        identification: id,
      };
      var url =
        "https://" +
        process.env.REACT_APP_BASE_URL +
        "/omnimap/generic/instances/" +
        id;

      omnimap
        .SaveOrEditAction(
          model,
          "PATCH",
          id,
          window.$catalog_management_units_token
        )
        .then(CallBackFunctions.beheereenheidEdit)
        .catch((error) => {
          console.log(error);
        });
    });
    function handleRefresh () {
      $("#spinner").removeAttr("hidden");
      ReloadData(1);
    }

    window.$catalog_discipline_refresh = handleRefresh;

    $(".refresh").click(handleRefresh);

    $(".back-page-link").click(function () {
      $("#tableSide").removeClass("d-none");
      $("#detailSide").addClass("d-none");
      $("#editSide").addClass("d-none");
    });
    $("#edit-button").click(function () {
      $("#editSide").removeClass("d-none");
      $("#detailSide").addClass("d-none");
    });
    $("#return-detail").click(function () {
      $("#detailSide").removeClass("d-none");
      $("#editSide").addClass("d-none");
    });

    $(".checkNone").click(function () {
      $("tbody tr").each(function () {
        $(this).attr("class", "odd");
      });
      $("#selected-rows-count").html("0" + " ");
      $(".checkNone, .checkAll").toggle();
    });
    $("div.popup").click(function () {
      var selectedIds = [];
      $("#example")
        .dataTable()
        .$("tr.selected")
        .each(function () {
          selectedIds.push($(this).attr("rowId"));
        });
      GetActionsOfRow(selectedIds.join(","));
    });

    $("#algemeen-naam").autocomplete({
      source: window.$catalog_discipline_algemeenNaam,
      select: function (event, ui) {
        addContentAndFillTable("algemeen-naam", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#algemeen-naam").on("input", function () {
      // that.algemeenNaam.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });
    function addContentAndFillTable(key, value) {
      var hasRow = $.grep(window.$catalog_discipline_content, function (v) {
        return v.key === key;
      });
      if (hasRow.length > 0) {
        window.$catalog_discipline_content = $.grep(
          window.$catalog_discipline_content,
          function (value) {
            return value != hasRow[0];
          }
        );
      }
      if (value != null) {
        var values = [];
        values.push(value);
        var contentModel = {
          and_or: "AND",
          datatype: "STRING",
          key: key,
          values: values,
        };
        window.$catalog_discipline_content.push(contentModel);
      }
      var definitions = [];
      let definition = process.env.REACT_APP_CATALOG_DISCIPLINE;
      var model = {
        content: window.$catalog_discipline_content,
        definitions: [definition],
      };
      window.$catalog_discipline_lastUsedTableFilter = model;
      that.fillTable(model, 1);
    }
    function fillDetail() {
      $("#algemeenNaam").html(
        window.$catalog_discipline_selectedRow.algemeenNaam
      );
      $("#algemeenNaam-tooltip").html(
        window.$catalog_discipline_selectedRow.algemeenNaam
      );
      if (window.$catalog_discipline_selectedRow.isActive)
        $("#discipline_active").attr("checked", "checked");
      else $("#discipline_active").removeAttr("checked");

      //editSide verilerin doldurulması
      $("#e-algemeenNaam").val(
        window.$catalog_discipline_selectedRow.algemeenNaam
      );
      $("#e-identification").val(
        window.$catalog_discipline_selectedRow.identification
      );

      if (window.$catalog_discipline_selectedRow.isActive)
        $("#e-discipline_active").attr("checked", "checked");
      else $("#e-discipline_active").removeAttr("checked");
    }

    function GetActionsOfRow(rowIds) {
      omnimap
        .GetActionsOfRowAction(rowIds, window.$catalog_management_units_token)
        .then(CallBackFunctions.GetActionsOfRowCallback)
        .catch((error) => {
          console.log(error);
        });
    }
    function fillFilterColumns(tableType) {
      let definition = process.env.REACT_APP_CATALOG_DISCIPLINE;
      var model = {
        definitions: [definition],
      };
      $.each(window.$catalog_discipline_columnList, function (index, data) {
        if (data.id != "" && data.filter == true) {
          omnimap
            .FillFilterColumnsAction(
              model,
              data.id,
              window.$catalog_management_units_token
            )
            .then((result) => {
              CallBackFunctions.FillFilterColumnsCallBack(data, result);
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    }
  }

  render() {
    return (
      <div id="tableSide">
        <table id="example" className="table-hover table min-full-width">
          <thead>
            <tr>
              <th className="sorting_disabled" style={{ width: "1%" }}>
                <span className="checkAll" />
                <span className="checkNone" style={{ display: "none" }} />
              </th>
              <th className="sorting_disabled" style={{ width: "1%" }}>
                <img
                  className="icon-table"
                  src={maatregelenSvg}
                  width={18}
                  height={18}
                />
              </th>
              <th>Naam discipline</th>
              {/* <th style={{ minWidth: 200 }}>Actief</th> */}
            </tr>
          </thead>
          <tbody></tbody>
        </table>
      </div>
    );
  }
}

export default Table;
